import { render, staticRenderFns } from "./CampaignRouterView.vue?vue&type=template&id=20d37dc3&"
import script from "./CampaignRouterView.vue?vue&type=script&lang=js&"
export * from "./CampaignRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports